import React, { useState, useEffect } from "react";
import Navbar from "../component/Navbar";

import BackgroundImage from "../assets/images/bg/bg2.webp";

import Property from "../component/Properties/property";
import Cta from "../component/cta";
import Footer from "../component/Footer";
import Switcher from "../component/Switcher";

export default function IndexEight() {
  const [bgLoaded, setBgLoaded] = useState(false);

  useEffect(() => {
    // Load background image asynchronously after initial render
    const img = new Image();
    img.src = BackgroundImage;
    img.onload = () => setBgLoaded(true);
  }, []);

  return (
    <>
      <Navbar />
      <section
        className="relative overflow-hidden md:h-[80vh] pt-36 md:pb-24 pb-32 bg-slate-600/10 dark:bg-slate-600/20 bg-no-repeat bg-bottom bg-cover"
        style={{ 
          backgroundImage: bgLoaded ? `url(${BackgroundImage})` : 'none',
          transition: 'background-image 0.3s ease'
        }}
      >
        <div className="container relative">
          <div className="grid grid-cols-1 items-center mt-10">
            <div className="text-center">
              <h1 className="font-bold lg:leading-normal leading-normal text-4xl lg:text-5xl mb-6">
                Panoramic Mountain Group <br /> & <br />
                Panoramic Highlands
              </h1>

              <p className="font-bold text-white text-xl max-w-xl mx-auto text-bold">
                Exquisite mountain properties and build sites.
              </p>

              <div className="subcribe-form z-1 max-w-2xl mx-auto mt-8">
                <a
                  href="/list"
                  className="inline-block px-8 py-3 bg-slate-700 text-white font-semibold rounded-2xl shadow-md hover:bg-slate-800 transition duration-300"
                >
                  🔍 Browse Listings
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="relative md:py-5 py-16">
        <Property />
      </section>

      <Cta />

      <Footer />
      <Switcher />
    </>
  );
}
